export type EventFile = {
  id: string
  nombre?: string
  url: string
};

export type AdminEventForm = {
  titulo: string
  descripcion?: string
  fechaInicio: string
  horaInicio: string
  fechaFin: string
  horaFin: string
  direccion?: string
  categoryOnline?: string
  categoryInPerson?: string
  emails: string[]
  allDate: boolean
  files?: File[]
  eventFiles?: EventFile[]
  promocionId: string
  noSendInvitation: boolean
};

export type EventProps = {
  eventoId: number
  titulo: string
  descripcion?: string
  fechaInicio: string
  fechaFin: string
  direccion?: string
  emailsInvitaciones: string[]
  allDate: boolean
  promocion: string
  promocionId: string
  enviarInvitacion: boolean
  ficheros?: EventFile[]
  categoria: EventCategoryType
};

export enum EventCategoryType {
  'hibrid' = 'HYBRID',
  'inPerson' = 'IN_PERSON',
  'online' = 'ONLINE',
}
